import { queryJSON } from "../index";

var locationUrl = function locationUrl() {
  var queryParams = queryJSON();

  if (typeof queryParams.location !== 'undefined') {
    return queryParams.location;
  }

  return '';
};

var locationIdsUrl = function locationIdsUrl() {
  var queryParams = queryJSON();
  var obj = {};

  if (typeof queryParams.storeid !== 'undefined' || typeof queryParams.cateringid !== 'undefined') {
    obj.vendorid = queryParams.storeid, obj.vendorcateringid = queryParams.cateringid;
  }

  if (typeof queryParams.retaincart !== 'undefined') {
    obj.retaincart = queryParams.retaincart;
  }

  Object.keys(obj).forEach(function (key) {
    return obj[key] === undefined ? delete obj[key] : {};
  });
  return obj;
};

var waitlistUrl = function waitlistUrl() {
  var queryParams = queryJSON();
  return queryParams.action === "getonlist";
};

export { locationUrl, waitlistUrl, locationIdsUrl };